import authAxios from '../authorization/axios';
import constants from '../constants';

export const banEmail = async (mail: string) => {
  const main = constants.api.banMail.replace('{mail}', mail);

  // TODO: typing the response.
  const response = await authAxios.post(main);

  return response;
};

export const getCompanies = async (filter: string) => {
  const main = `${constants.api.getCompanies}?filters=${filter}`;

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};

export const deleteContactCompany = async (contactId: any, companyId: any) => {
  const main = constants.api.deleteContactCompany
    .replace(':id', `${contactId}`)
    .replace(':company_id', `${companyId}`);

  // TODO: typing the response.
  const response = await authAxios.delete(main);

  return response;
};

export const refreshKycOnboarding = async (id: any) => {
  const main = constants.api.refreshKycOnboarding.replace('{id}', id);

  // TODO: typing the response.
  const response = await authAxios.post(main);

  return response;
};


export const updateBusiness = async (businessId: any, businessName: string, businessVat: string) => {
  const main = constants.api.updateBusiness.replace('{companyId}', businessId.toString());

  // TODO: typing the response.
  const response = await authAxios.put(main, { business_name: businessName, vat: businessVat });

  return response;
};

export const createContactCompany = async (contactId: any, businessName: string, businessVat: string) => {
  const main =   constants.api.createContactCompany.replace(':id', contactId.toString());

  // TODO: typing the response.
  const response = await authAxios.post(main, { business_name: businessName, vat: businessVat });

  return response;
};

export const getContact = async (contactId: any) => {
  const main =  constants.api.getContact.replace('{contactId}', contactId.toString());

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};


export const addContact = async (data: any) => {
  const main =  constants.api.addContact;

  // TODO: typing the response.
  const response = await authAxios.post(main, data);

  return response;
};



export const updateContact = async (id: any, name: string | undefined, surname: string | undefined, phone: string | undefined) => {
  const main =  constants.api.updateContact;

  // TODO: typing the response.
  const response = await authAxios.put(main, { id, name, surname, phone });

  return response;
};





